import { DateHelper } from '../helpers/date.helper';
import { MathHelper } from '../helpers/math.helper';
import { DateRange } from './date-range.type';

export class DataAvailabilityInfo {
  readonly firstDate: Date;
  readonly lastDate: Date;
  readonly isValid: boolean;

  constructor(
    public readonly datesWithData: DateRange[],
    isValid: boolean,
  ) {
    if (this.datesWithData?.length > 0) {
      this.firstDate = DateHelper.startOfDay(datesWithData[0].start);
      this.lastDate = DateHelper.startOfDay(datesWithData[datesWithData.length - 1].end);
    }

    this.isValid = isValid;
  }

  hasDataForDate(date: Date): boolean {
    if (!this.isValid || !this.datesWithData) {
      return false;
    }

    return this.datesWithData?.some(x => date >= x.start && date <= x.end);
  }

  hasAnyDataForInterval(range: DateRange): boolean {
    if (!this.isValid) {
      return false;
    }

    return this.datesWithData?.some(x => x.overlaps(range));
  }

  reduceIntervalToAvailableData(range: DateRange): DateRange {
    if (!this.isValid) {
      return range;
    }

    const start = new Date(MathHelper.clamp(range.start.getTime(), this.firstDate?.getTime(), this.lastDate?.getTime()));
    const end = new Date(MathHelper.clamp(range.end.getTime(), this.firstDate?.getTime(), this.lastDate?.getTime()));
    const result = new DateRange(start, end);

    if (result.isValid()) {
      return result;
    } else {
      throw new Error('Invalid date range');
    }
  }
}
